<template>
    <div>
        <div v-if="stateSelect">
            <b-form-select v-model="selected" @change="selectCustomer">
                <b-form-select-option v-for="customer in customerList" :key="customer.id" :value="customer.id">
                    {{customer.name}}
                </b-form-select-option>
            </b-form-select>

            <GekkoButton 
                v-if="isSupplier() && !hideNewBtn"
                @click="changeState"
                :text="$gettext('Add new supplier')" 
                icon="fa-solid fa-plus"
                variant="link text-blue"
                size="sm"
            />
            <GekkoButton 
                v-if="isCustomer() && !hideNewBtn"
                @click="changeState"
                :text="$gettext('Add new customer')" 
                icon="fa-solid fa-plus"
                variant="link text-blue"
                size="sm"
            />

        </div>
        <div v-if="!stateSelect">
            <b-form @submit="onSubmit">
                <b-container fluid class="gk-subform gk-input-light">
                    <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label" :label="$gettext('Name')" label-for="input-4" class="padding-top-5">
                        <b-form-input id="input-4" v-model="customer.name" :placeholder="$gettext('John Smith')" required></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label" :label="$gettext('VAT Number')" label-for="input-4">
                        <b-form-input id="input-4" v-model="customer.btw" :placeholder="$gettext('999999')"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-8" label-class="gk-label-margin gk-modal-label" :label="$gettext('Country') + '*'" label-for="input-8">
                        <b-form-select id="input-8" v-model="customer.country" :options="countries" required></b-form-select>
                    </b-form-group>

                    <div class="d-flex justify-content-end align-items-center">
                        <GekkoButton 
                            @click="cancel"
                            :text="$gettext('Cancel')" 
                            variant="link"
                            class="text-primary mr-2"
                            size="sm"
                        />
                        <GekkoButton 
                            :text="$gettext('Create')" 
                            icon="fa-regular fa-floppy-disk"
                            type="submit"
                            size="sm"
                        />
                    </div>

                </b-container>
            </b-form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    
    import CustomerService from "@/store/services/customer.service.js";
    import CompanyService from "@/store/services/company.service.js";
    import GekkoButton from "@/components/GekkoButton";

    export default {
        name: "CustomerSelector",
        props: {
            value: Number,
            filters: Object,
            hideNewBtn: {
                type: Boolean,
                default: false
            },
            noCustomer: {
                type: Boolean,
                default: false
            },
        },
        watch: {
            value: function (newVal, oldVal) {
                if(newVal !== oldVal){
                    this.selected = newVal;
                }
            }
        },
        components: { GekkoButton },
        data() {
            return {
                selected: null,
                customerList: [],
                stateSelect: true,
                customer: {},
                countries: [],
            }
        },
        computed: {
            ...mapGetters({ 
                currentCompany: "main/getCurrentCompany",
                getCompanyId: 'main/getCompanyId',
            }),
        },
        created(){
            this.getCustomerList(this.value);
            if (this.noCustomer) this.selected = 0
        },
        methods: {
            onSubmit(evt){
                evt.preventDefault();
                let vm = this;
                CustomerService.create(this.customer).then(function (response) {
                    vm.$store.commit('setAlert', {title: vm.$gettext("Customer created"), text:response.data.name + " has been created", variant:"success",duration:4});
                    vm.getCustomerList(response.data.id);
                    vm.cancel();
                }).catch(function (error) {
                    if(error.status === 400){
                        let firstDictKey = Object.keys(error.data)[0];
                        let text = error.data[firstDictKey];
                        vm.$store.commit('setAlert', {title: vm.$gettext("Error creating customer"), text:text, variant:"danger",duration:4});
                    }else{
                        vm.$store.commit('setAlert', {title: vm.$gettext("Error creating customer"), text:vm.$gettext("The customer could not be created."), variant:"danger",duration:4});
                    }
                })
            },
            getCustomerList(preselect_customer){
                var vm = this;
                CustomerService.list(this.filters).then(function (response) {
                    vm.customerList = response.data;
                    if (vm.noCustomer) {
                        vm.customerList.unshift({name: vm.$gettext('No Customer'), id: 0});
                    } else {
                        vm.customerList.unshift({name: vm.$gettext('Nothing Selected'), id: null});
                    }
                    if(preselect_customer){
                        vm.selectCustomer(preselect_customer);
                    }
                })
            },
            selectCustomer(customer){
                this.selected = customer;
                this.$emit('input', customer);
                this.$emit('change', customer);
            },
            isSupplier(){
                if(this.filters.is_supplier === 'True'){
                    return true;
                }
                return false;
            },
            isCustomer(){
                if(this.filters.is_customer === 'True'){
                    return true;
                }
                return false;
            },
            changeState(){
                this.stateSelect=!this.stateSelect;
                CompanyService.getCountries().then((response) => {
                    this.countries = response.data;
                    this.customer = {
                        country: this.currentCompany.country,
                        owner_company: this.getCompanyId,
                        is_supplier: this.isSupplier(),
                        is_customer: this.isCustomer(),
                    };
                });
            },
            cancel(){
                this.stateSelect=!this.stateSelect;
            }
        }
    };
</script>
<style lang="scss" scoped>
    .padding-top-5{
        padding-top:5px;
    }
</style>